import template from './expense-review.html';
import controller from './expense-review.controller';

let expenseReviewComponent = {
  restrict: 'E',
  bindings: {
    contractId: '<'
  },
  template,
  controller
};

export default expenseReviewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review/expense-review.component.js